export default __webpack_public_path__ + "static/media/review-sample-photo-1.330421f1.jpg";